module.exports = __webpack_public_path__ + "static/img/icon.8435a5b8.svg";